var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center gap-2"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status","aria-hidden":"true"}}),_c('strong',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }